var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdioma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#000E4B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.984 0C7.152 0 0 7.168 0 16C0 24.832 7.152 32 15.984 32C24.832 32 32 24.832 32 16C32 7.168 24.832 0 15.984 0ZM27.072 9.6H22.352C21.84 7.6 21.104 5.68 20.144 3.904C23.088 4.912 25.536 6.96 27.072 9.6ZM16 3.264C17.328 5.184 18.368 7.312 19.056 9.6H12.944C13.632 7.312 14.672 5.184 16 3.264ZM3.616 19.2C3.36 18.176 3.2 17.104 3.2 16C3.2 14.896 3.36 13.824 3.616 12.8H9.024C8.896 13.856 8.8 14.912 8.8 16C8.8 17.088 8.896 18.144 9.024 19.2H3.616ZM4.928 22.4H9.648C10.16 24.4 10.896 26.32 11.856 28.096C8.912 27.088 6.464 25.056 4.928 22.4ZM9.648 9.6H4.928C6.464 6.944 8.912 4.912 11.856 3.904C10.896 5.68 10.16 7.6 9.648 9.6ZM16 28.736C14.672 26.816 13.632 24.688 12.944 22.4H19.056C18.368 24.688 17.328 26.816 16 28.736ZM19.744 19.2H12.256C12.112 18.144 12 17.088 12 16C12 14.912 12.112 13.84 12.256 12.8H19.744C19.888 13.84 20 14.912 20 16C20 17.088 19.888 18.144 19.744 19.2ZM20.144 28.096C21.104 26.32 21.84 24.4 22.352 22.4H27.072C25.536 25.04 23.088 27.088 20.144 28.096ZM22.976 19.2C23.104 18.144 23.2 17.088 23.2 16C23.2 14.912 23.104 13.856 22.976 12.8H28.384C28.64 13.824 28.8 14.896 28.8 16C28.8 17.104 28.64 18.176 28.384 19.2H22.976Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdioma);
export default __webpack_public_path__ + "static/media/idioma.0abeadbd62dd5c23d51faae413df3836.svg";
export { ForwardRef as ReactComponent };